import { Message } from "@gumtree/shared/src/types/message-centre";

export function hasEachParticipantSentMinMessageCount(messages: Message[], userId: number): any {
    const userCounts = messages.reduce(
        (counts, message) => {
            if (message.userId === userId) {
                counts.userMessages++;
            } else {
                counts.revieweeMessages++;
            }

            return counts;
        },
        { userMessages: 0, revieweeMessages: 0 }
    );

    return (
        userCounts.userMessages >= 2 &&
        userCounts.revieweeMessages >= 2
    );
}
